import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFilledDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 10,
	viewBox: "0 0 16 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.7636 0H7.64397H1.23282C0.135733 0 -0.412812 1.51783 0.364293 2.4076L6.28404 9.18548C7.23256 10.2715 8.77534 10.2715 9.72387 9.18548L11.9752 6.60779L15.6436 2.4076C16.4093 1.51783 15.8607 0 14.7636 0Z",
		fill: "currentColor"
	})
});
export default SvgArrowFilledDown;
